import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigationContext } from '../../context/NavigationContext';
import { SectionIDs } from '../../data/Sections';

import styles from './styles.module.scss';

export default function ScrollView(): JSX.Element {
  const { t } = useTranslation('ai4Jokes');
  const { activeSectionID } = useNavigationContext();

  return (
    <div 
      className={styles.scrollView}
      data-first={[SectionIDs.Intro1, SectionIDs.Conclusion].includes(activeSectionID)}
      data-end={[SectionIDs.TellMeAJoke, SectionIDs.About].includes(activeSectionID)}
    >
      <div className={styles.innerContainer}>
        {t('misc.scroll')}
        <div className={styles.line}></div>
      </div>
    </div>
  );
}
